import { auth } from "./auth.js";
import { API, rifledCategoryURL, smoothboreCategoryURL, TOKEN } from "./config.js";
import { getData } from "./data.js";
import { getLocation, getLocationURL, setLocation } from "./healpers.js";
import { loadWeaponList } from "./loadWeaponList.js";
import { loadWeaponPage } from "./weapon.js";

window.addEventListener("reload", () => {
  window.location.href = "http://74.am/";
});

export const init = () => {
  if (getLocationURL() === smoothboreCategoryURL || !getLocation()) {
    setLocation(smoothboreCategoryURL);
    loadWeaponList();
    return;
  }

  if (getLocationURL() === rifledCategoryURL) {
    setLocation(rifledCategoryURL);
    loadWeaponList();
    return;
  }

  if (getLocationURL() !== smoothboreCategoryURL && getLocationURL() !== rifledCategoryURL) {
    const id = getLocationURL();
    loadWeaponPage(+id);
    return;
  }
};

if (!TOKEN) {
  auth();
}

if (TOKEN) {
  getData(`${API}test`).then((data) => {
    if (data.data.isAuthenticated === false) {
      auth();
    } else {
      init();
    }
  });
}
